const cleanups = new Map<HTMLElement, () => void>();

export function teardownTaskWorkspace() {
  cleanups.forEach((cleanup) => cleanup());
  cleanups.clear();
}

export function initTaskWorkspace() {
  document.querySelectorAll<HTMLElement>("[data-task-workspace]").forEach((workspace) => {
    if (cleanups.has(workspace)) return;
    const dialog = workspace.querySelector<HTMLDialogElement>("[data-task-preview-dialog]");
    const content = dialog?.querySelector<HTMLElement>("[data-task-preview-content]");
    if (!dialog || !content) return;
    let trigger: HTMLElement | null = null;
    const onClick = (event: MouseEvent) => {
      const groupControl = (event.target as Element).closest<HTMLElement>("[data-task-groups-open]");
      if (groupControl) {
        workspace.querySelectorAll<HTMLDetailsElement>("[data-task-patient-group]").forEach((group) => {
          group.open = groupControl.dataset.taskGroupsOpen === "true";
        });
        return;
      }
      const button = (event.target as Element).closest<HTMLElement>("[data-task-preview]");
      if (!button || !workspace.contains(button)) return;
      const template = document.getElementById(button.dataset.taskPreview!);
      if (!(template instanceof HTMLTemplateElement) || !workspace.contains(template)) return;
      trigger = button;
      content.replaceChildren(template.content.cloneNode(true));
      dialog.showModal();
    };
    const onClose = () => {
      content.replaceChildren();
      trigger?.focus();
    };
    workspace.addEventListener("click", onClick);
    dialog.addEventListener("close", onClose);
    cleanups.set(workspace, () => {
      if (dialog.open) dialog.close();
      content.replaceChildren();
      workspace.removeEventListener("click", onClick);
      dialog.removeEventListener("close", onClose);
    });
  });
}
